import { Modal } from "@mui/material";
import styled from "styled-components";
import ButtonComponent from "../button";
import IconPrinter from '../../assets/images/icon-printer.svg'
import QRCode from "react-qr-code";
import * as htmlToImage from "html-to-image";
import { useEffect, useState } from "react";
import EFQRcodePrinterModal from "./ef-qrcode-printer";

const Container = styled.div`
    /* width: 400px; */
    padding: 36px;
    border-radius: 16px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 30px 0px #00266F29;
    display: flex;
    flex-direction: column;

    &:focus-visible {
        outline: none;
    }

    .image {
        margin-bottom: 24px;
    }

    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin-bottom: 8px;
    }

    .sub-label {
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: center;
        white-space: pre-line;
        margin-bottom: 24px;
    }

    .button-container {
        margin-top: auto;
        margin-bottom: 0px;

        .button-box {
            width: 100%;
        }
    }
`;

const QRCodeBox = styled.div`
    width: calc(100% - 34px);
    height: calc(190px - 32px);
    border-radius: 16px;
    border: 1px solid #25368D;
    background-color: #F2F5FE;
    padding: 16px;
    gap: 24px;

    &.anonymous {
        background-color: #EBF9F9;
    }

    .image-box {
        width: 160px;
        min-width: 160px;
        height: 100%;
        border-radius: 8px;
        background-color: #E3E9FD;
        padding: 2px 0px 0px 2px;
        cursor: pointer;
    }

    .label-box {
        width: 100%;

        .label-placeholder {
            color: #2A2A2A;
            font-size: 20px;
            font-weight: 500;
            line-height: 29.9px;
            text-align: left;
        }
    }
`;

function EFQRcodeModal({
    open,
    dataItem,
    buttonLabel,
    styleContainer,
    onClose,
}) {
    const [openQRcodeModal, setOpenQRcodeModal] = useState(false);
    const [detailQRcodeModal, setDetailQRcodeModal] = useState({
        id: "",
        displayname: "",
        title: "",
        type: "",
        province: "",
        location: "",
        url_qrcode: "",
        qrcode_description: "",
    });
    const [information, setInformation] = useState({
        id: "",
        displayname: "",
        url_qrcode: "",
        url_qrcode_anonymous: "",
        evaluation_form_detail: null,
    });

    useEffect(() => {
        if (dataItem) {
            onSetInformation(dataItem)
        }
    }, [dataItem])

    async function onSetInformation(param) {
        let detail = {
            ...information
        };
        detail.id = param?.id;
        detail.displayname = param?.evaluation_name;
        detail.evaluation_form_detail = param?.evaluation_form_detail;
        const lineLiffId = process.env.REACT_APP_LINE_LIFF_ID || "";
        if (lineLiffId) {
            const lineUrl = 'https://liff.line.me';
            detail.url_qrcode = `${lineUrl}/${lineLiffId}?evaluation_form_id=${detail.id}`
            detail.url_qrcode_anonymous = `${lineUrl}/${lineLiffId}?evaluation_form_id=${detail.id}&mode=anonymous`
        }
        setInformation(detail)
    }

    function handleConfirm() {
        onClose && onClose();
    }
    function handleDownloadQrCode(id) {
        const qrCodeElement = document.getElementById(id);
        if (!qrCodeElement) return
        htmlToImage
            .toSvg(qrCodeElement)
            .then(function (dataUrl) {
                const link = document.createElement("a");
                link.href = dataUrl;
                link.download = `${id}.svg`;
                link.click();
            })
            .catch(function (error) {
                console.error("Error generating QR code:", error);
            });
    }
    function handleOpenQRExam(param) {
        const detail = {
            ...detailQRcodeModal,
            title: "",
            type: "",
            province: "",
            location: "",
        }
        detail.id = information.id;
        detail.displayname = information.displayname;
        if (param === "normal") {
            detail.anonymous = false;
            detail.url_qrcode = information.url_qrcode;
            detail.qrcode_description = "แบบสอบถามด้วยคิวอาร์โค้ด";
        } else if (param === "anonymous") {
            detail.anonymous = true;
            detail.url_qrcode = information.url_qrcode_anonymous;
            detail.qrcode_description = "แบบสอบถามไม่ระบุตัวตนด้วยคิวอาร์โค้ด";
        }
        detail.title = information.evaluation_form_detail?.evaluation_form_evaluation_data?.title;
        detail.type = information.evaluation_form_detail?.evaluation_form_evaluation_type;
        detail.province = information.evaluation_form_detail?.location_province;
        detail.location = information.evaluation_form_detail?.location_location_name;
        setDetailQRcodeModal(detail);
        setOpenQRcodeModal(true);
    }
    function handleCloseQRCode() {
        setOpenQRcodeModal(false)
    }

    return (
        <>
            <EFQRcodePrinterModal
                open={openQRcodeModal}
                dataItem={detailQRcodeModal}
                buttonLabel={"ปิด"}
                onConfirm={handleCloseQRCode}
            />
            <Modal
                className="content-center"
                open={open || false}
            >
                <Container
                    style={{ ...styleContainer }}
                >
                    <div className="label content-center">{information.displayname || ""}</div>

                    {information.url_qrcode &&
                        <QRCodeBox className="vertical-center" style={{ margin: "24px 0px" }}>
                            <div className="label-box">
                                <div className="label-placeholder">ดูตัวอย่างแบบสอบถาม<br />ด้วยคิวอาร์โค้ด</div>
                                <ButtonComponent
                                    label={"พิมพ์คิวอาร์โค้ด"}
                                    icon={IconPrinter}
                                    variant={"primary"}
                                    sceenSize={"lg"}
                                    style={{
                                        width: "190px",
                                        maxWidth: "190px",
                                        minWidth: "190px",
                                        height: "40px",
                                        marginTop: "12px",
                                        fontSize: "15px",
                                        fontWeight: "500",
                                    }}
                                    onClick={(e) => handleOpenQRExam("normal")}
                                />
                            </div>
                            <div className="image-box content-center" onClick={(e) => handleDownloadQrCode("qrcode")}>
                                <QRCode
                                    id="qrcode"
                                    value={information.url_qrcode}
                                    size={160}
                                />
                            </div>
                        </QRCodeBox>
                    }
                    {information.url_qrcode_anonymous &&
                        <QRCodeBox className="vertical-center anonymous" style={{ marginBottom: "24px" }}>
                            <div className="label-box">
                                <div className="label-placeholder">ดูตัวอย่างแบบสอบถามไม่ระบุตัวตน<br />ด้วยคิวอาร์โค้ด</div>
                                <ButtonComponent
                                    label={"พิมพ์คิวอาร์โค้ด"}
                                    icon={IconPrinter}
                                    variant={"primary"}
                                    sceenSize={"lg"}
                                    style={{
                                        width: "190px",
                                        maxWidth: "190px",
                                        minWidth: "190px",
                                        height: "40px",
                                        marginTop: "12px",
                                        fontSize: "15px",
                                        fontWeight: "500",
                                    }}
                                    onClick={(e) => handleOpenQRExam("anonymous")}
                                />
                            </div>
                            <div className="image-box content-center" onClick={(e) => handleDownloadQrCode("qrcode-anonymous")}>
                                <QRCode
                                    id="qrcode-anonymous"
                                    value={information.url_qrcode_anonymous}
                                    size={160}
                                />
                            </div>
                        </QRCodeBox>
                    }

                    <div className="button-container horizontal-center">
                        <div className="button-box">
                            <ButtonComponent
                                label={buttonLabel || "กลับหน้าหลัก"}
                                variant={"primary"}
                                sceenSize={"lg"}
                                style={{ maxWidth: "100%" }}
                                onClick={handleConfirm}
                            />
                        </div>
                    </div>
                </Container>
            </Modal>
        </>
    )
}

export default EFQRcodeModal;